import React, { forwardRef, PropsWithChildren } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import inputLabels from 'common/messages/inputLabels';
import { useRenderIntlMessage } from 'common/hooks/useRenderIntlMessage';
import { TextField } from 'common/components/index';

const useStyles = makeStyles((theme: Theme) => ({
  phoneInput: {
    '& .MuiFormLabel-root': {
      transition: 'none',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(70px, 8px) scale(0.675)',
    },
    '& .MuiInputBase-input.MuiOutlinedInput-input': {
      paddingLeft: theme.spacing(8.75),
    },
  },
  phoneInputEmpty: {
    '& .MuiFormLabel-root:not(.Mui-focused)': {
      marginLeft: '48px',
    },
  },
}));

const CustomPhoneNumberInput = forwardRef((props: PropsWithChildren<any>, ref) => {
  const { name, helperText, error, recommended, label, value, ...otherProps } = props;
  const { formState } = useFormContext();
  const { errors } = formState;
  const renderIntlMessage = useRenderIntlMessage();
  const classes = useStyles();

  return (
    <TextField
      {...{ ...otherProps, name }}
      inputRef={ref}
      value={value}
      fullWidth
      label={label || <FormattedMessage {...inputLabels.phone} />}
      variant="outlined"
      className={classNames(classes.phoneInput, {
        [classes.phoneInputEmpty]: !value,
      })}
      error={error || !!errors[name]}
      helperText={renderIntlMessage(helperText || errors[name]?.message)}
      recommended={recommended}
    />
  );
});

export default CustomPhoneNumberInput;
